module.exports = __webpack_public_path__ + "static/media/about_us.b342d877.png";